import { render, staticRenderFns } from "./AppGlobalAlerts.vue?vue&type=template&id=c32046b2&"
import script from "./AppGlobalAlerts.vue?vue&type=script&lang=ts&"
export * from "./AppGlobalAlerts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports